// TODO in devkit?
export class BetFailedError extends Error {
    public readonly wrappedError: Error | undefined;

    constructor(error?: Error) {
        super();
        this.wrappedError = error;
    }
}

export class BetCancelFailedError extends Error {
    public readonly wrappedError: Error | undefined;

    constructor(error?: Error) {
        super();
        this.wrappedError = error;
    }
}

export class BetCashOutFailedError extends Error {
    public readonly wrappedError: Error | undefined;

    constructor(error?: Error) {
        super();
        this.wrappedError = error;
    }
}
